import { Map } from 'immutable';

import * as t from '../actions/manageSubscriptionActionTypes';

const initialState = Map({
  cancelSubscriptionWaiting: false,
  cancelSubscriptionSuccess: false,
  cancelSubscriptionMessage: { type: 'success', text: '' },
  revertCancellationWaiting: false,
  revertCancellationSuccess: false,
  revertCancellationMessage: { type: 'success', text: '' },
  subscriptionOperationWaiting: false,
  subscriptionOperationSuccess: false,
  subscriptionOperationMessage: { type: 'success', text: '' },
  subscriptionActivationWaiting: false,
  subscriptionActivationSuccess: false,
  subscriptionActivationMessage: { type: 'success', text: '' },
  updateSubscriptionPlanWaiting: false,
  updateSubscriptionPlanSuccess: false,
  updateSubscriptionPlanMessage: { type: 'success', text: '' },
  refundAmountMessage: { type: 'success', text: '' },
});

const reducer = function manageSubscriptionReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.SET_CANCEL_SUBSCRIPTION_MESSAGE:
      return state.set('cancelSubscriptionMessage', action.message);
    case t.SET_CANCEL_SUBSCRIPTION_SUCCESS:
      return state.set('cancelSubscriptionSuccess', action.value);
    case t.SET_CANCEL_SUBSCRIPTION_WAITING:
      return state.set('cancelSubscriptionWaiting', action.value);
    case t.SET_REVERT_CANCELLATION_MESSAGE:
      return state.set('revertCancellationMessage', action.message);
    case t.SET_REVERT_CANCELLATION_SUCCESS:
      return state.set('revertCancellationSuccess', action.value);
    case t.SET_REVERT_CANCELLATION_WAITING:
      return state.set('revertCancellationWaiting', action.value);
    case t.SET_SUBSCRIPTION_OPERATION_MESSAGE:
      return state.set('subscriptionOperationMessage', action.message);
    case t.SET_SUBSCRIPTION_OPERATION_SUCCESS:
      return state.set('subscriptionOperationSuccess', action.value);
    case t.SET_SUBSCRIPTION_OPERATION_WAITING:
      return state.set('subscriptionOperationWaiting', action.value);
    case t.SET_SUBSCRIPTION_ACTIVATION_MESSAGE:
      return state.set('subscriptionActivationMessage', action.message);
    case t.SET_SUBSCRIPTION_ACTIVATION_SUCCESS:
      return state.set('subscriptionActivationSuccess', action.value);
    case t.SET_SUBSCRIPTION_ACTIVATION_WAITING:
      return state.set('subscriptionActivationWaiting', action.value);
    case t.SET_UPDATE_SUBSCRIPTION_PLAN_MESSAGE:
      return state.set('updateSubscriptionPlanMessage', action.message);
    case t.SET_REFUND_AMOUNT_MESSAGE:
      return state.set('refundAmountMessage', action.message);
    case t.SET_UPDATE_SUBSCRIPTION_PLAN_SUCCESS:
      return state.set('updateSubscriptionPlanSuccess', action.value);
    case t.SET_UPDATE_SUBSCRIPTION_PLAN_WAITING:
      return state.set('updateSubscriptionPlanWaiting', action.value);
    case t.RESET_COMPONENT:
      return state
        .set('cancelSubscriptionWaiting', false)
        .set('cancelSubscriptionSuccess', false)
        .set('cancelSubscriptionMessage', { type: 'success', text: '' })
        .set('revertCancellationWaiting', false)
        .set('revertCancellationSuccess', false)
        .set('revertCancellationMessage', { type: 'success', text: '' })
        .set('subscriptionOperationWaiting', false)
        .set('subscriptionOperationSuccess', false)
        .set('subscriptionOperationMessage', { type: 'success', text: '' })
        .set('subscriptionActivationWaiting', false)
        .set('subscriptionActivationSuccess', false)
        .set('subscriptionActivationMessage', { type: 'success', text: '' })
        .set('updateSubscriptionPlanWaiting', false)
        .set('updateSubscriptionPlanSuccess', false)
        .set('updateSubscriptionPlanMessage', { type: 'success', text: '' });
    default:
      return state;
  }
};

export default reducer;
